import { ProductForm } from '@shopify/theme-product-form';
import * as cart from '@shopify/theme-cart';
import {formatMoney} from '@shopify/theme-currency';

export default function init ({ el, context }) {

  const formElement = el.querySelector('form')
  const productHandle = formElement.dataset.productHandle;
  const productPriceElement = el.querySelector('.price')
  const productComparePriceElement = el.querySelector('.compare-price')
  let productVaries = false
  let productMinPrice = 0
  let productCompareAtPrice = 0
  const addButton = formElement.querySelector('button')
  const idSelector = formElement.querySelector('[name="id"]')
  const selectWrapper = idSelector.previousElementSibling
  const showMoreButton = document.querySelector('.product-detail__show-more-button')
  const productDetailContentBox = document.querySelector('.product-detail__content__inner')
  let product
  const cartTrigger = document.querySelector('[data-module-drawers-trigger="cart"]');
  
  // Fetch the product data from the .js endpoint because it includes
  // more data than the .json endpoint. Alternatively, you could inline the output
  // of {{ product | json }} inside a <script> tag, with the downside that the
  // data can never be cached by the browser.
  //
  // You will need to polyfill `fetch()` if you want to support IE11
  
  addButton.addEventListener('click', (e) => {
    e.preventDefault();
    if(idSelector.value !== ""){
      cart.addItemFromForm(formElement).then(item => {
        addButton.innerText = 'Added to bag'
        setTimeout(function(){
          addButton.innerText = 'Add to bag'
        }, 2000);
        let existingItem = document.querySelector(`[data-variant-id="${item.variant_id}"]`)
        if(existingItem === null){

        } else {
          let quantity = existingItem.querySelector('quantity')
          quantity.innerText = `x ${item.quantity}`
        }
        let itemCount = document.querySelector('.item-count')
        itemCount.dataset.itemCount = parseInt(itemCount.innerText) + 1
        itemCount.innerText = parseInt(itemCount.innerText) + 1
        const anEvent = new Event('addedToCart');
        document.dispatchEvent(anEvent)
      });
    } else {
      selectWrapper.classList.add('option-error')
      setTimeout(function() {
        selectWrapper.classList.remove('option-error')
      }, 3000);
    }
  });

  fetch(`/products/${productHandle}.js`)
    .then(response => {
      return response.json();
    })
    .then(productJSON => {
      productVaries = productJSON.price_varies
      productMinPrice = productJSON.price_min
      productCompareAtPrice = productJSON.compare_at_price
      const productForm = new ProductForm(formElement, productJSON, {
        onOptionChange
      });
    });

  function selectId(variant) {
    let option = idSelector.querySelector(`option[value="${variant.id}"]`)
    option.selected = true
  }

  function selectImage(variant){
    var img = variant.featured_image.src.replace('.jpg', '_600x.jpg')    
    var imageElement = el.parentElement.parentElement.children[2].firstElementChild.firstElementChild
    imageElement.removeAttribute('srcset')
    imageElement.src = img
    imageElement.classList.add('lazy-load')
  }

  function addOutOfStock(variant){
    addButton.innerText = "Out of stock"
    addButton.disabled = true
  }
  function removeOutOfStock(variant){
    addButton.innerText = "Add to bag"
    addButton.disabled = false
  }

  // This function is called whenever the user changes the value of an option input
  function onOptionChange() {
    
  }

  if(showMoreButton){
    showMoreButton.addEventListener('click', function(e) {
      productDetailContentBox.classList.remove("hide-half-mobile");
      showMoreButton.style.display = "none";
    })
  }

}